import React, { useState } from 'react';
import "../styles/AddPerformanceModal.css";

const AddPerformanceModal = ({ isOpen, onClose, studentId, onPerformanceAdded }) => {
    const [note, setNote] = useState('');
    const [rating, setRating] = useState('');
    const [errors, setErrors] = useState({});
    const [popupError, setPopupError] = useState('');
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        let validationErrors = {};
        if (!note.trim()) validationErrors.note = "Note is required";
        if (!rating.trim()) validationErrors.rating = "Rating is required";

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setPopupError('');

        const newPerformance = {
            note,
            rating,
            studentId,
        };

        try {
            const res = await fetch('/api/student-performance', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newPerformance),
            });

            if (res.ok) {
                const data = await res.json();
                onPerformanceAdded(data);
                onClose();
                setNote('');
                setRating('');
            } else {
                setPopupError("Failed to add performance."); 
            }
        } catch (error) {
            console.error('Error submitting performance:', error);
            setPopupError("Server error. Please try again."); 
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="modal-title">Add Performance</h3>
                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="form-group">
                        <label htmlFor="note">Note</label>
                        <input
                            id="note"
                            type="text"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            className={`input-field ${errors.note ? 'error-border' : ''}`}
                        />
                        {errors.note && <p className="error-text">{errors.note}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="rating">Rating</label>
                        <input
                            id="rating"
                            type="text"
                            value={rating}
                            onChange={(e) => setRating(e.target.value)}
                            className={`input-field ${errors.rating ? 'error-border' : ''}`}
                        />
                        {errors.rating && <p className="error-text">{errors.rating}</p>}
                    </div>

                    <div className="modal-actions">
                        <button type="submit" className="save-btn">Save Performance</button>
                        <button className="performance-cancel-btn" onClick={onClose}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddPerformanceModal;
